import { useRef, useState } from "react"
import axiosInstance from "../Services/Api"

const NewPasswordModal = ({ setShowPassword }) => {
    const password = useRef()
    const newPassword = useRef()
    const [wrongPassword, setWrongPassword] = useState(false)
    const [disabled, setDisabled] = useState(false)
    const handleOverlayClick = () => {
        setShowPassword(false);
    };

    const handleChangePassword = async (e) => {
        setDisabled(true)
        e.preventDefault();
        try {
            const data = {
                password: password.current.value,
                newPassword: newPassword.current.value
            }
            const response = await axiosInstance.post('/api/resetPassword', data)
            if (response.status === 200) {
                setDisabled(false)
                alert('senha trocada com sucesso')
                localStorage.removeItem('token')
                window.location.reload()
            }
            setDisabled(false)

        } catch (e) {
            setDisabled(false)
            if (e.status === 401) {
                localStorage.removeItem('token')
                window.location.reload()
            }
            if (e.status === 400) {
                setWrongPassword(true)
            }
        }


    }
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[99999]" onClick={handleOverlayClick}>
            <div className="rounded-[10px] md:w-[400px] w-[80%] z-[99999] bg-[#1D1D1D] px-0 p-3" onClick={(e) => e.stopPropagation()}>
                <div className="w-full px-3 relative pb-2 text-white border-b border-[#474747]">
                    <svg onClick={() => { setShowPassword(false) }} className="absolute right-[15px] top-[5px]" width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.2637 11.4238C12.3188 11.4789 12.3626 11.5444 12.3925 11.6165C12.4223 11.6886 12.4377 11.7658 12.4377 11.8438C12.4377 11.9219 12.4223 11.9991 12.3925 12.0712C12.3626 12.1433 12.3188 12.2087 12.2637 12.2639C12.2085 12.3191 12.143 12.3628 12.0709 12.3927C11.9989 12.4226 11.9216 12.4379 11.8436 12.4379C11.7656 12.4379 11.6883 12.4226 11.6162 12.3927C11.5442 12.3628 11.4787 12.3191 11.4235 12.2639L6.49984 7.3395L1.57617 12.2639C1.46476 12.3753 1.31365 12.4379 1.15609 12.4379C0.998532 12.4379 0.847425 12.3753 0.736014 12.2639C0.624602 12.1525 0.562012 12.0014 0.562012 11.8438C0.562012 11.6863 0.624602 11.5352 0.736014 11.4238L5.66043 6.50009L0.736014 1.57641C0.624602 1.465 0.562012 1.3139 0.562012 1.15634C0.562012 0.998776 0.624602 0.84767 0.736014 0.736258C0.847425 0.624846 0.998532 0.562256 1.15609 0.562256C1.31365 0.562256 1.46476 0.624846 1.57617 0.736258L6.49984 5.66067L11.4235 0.736258C11.5349 0.624846 11.686 0.562256 11.8436 0.562256C12.0012 0.562256 12.1523 0.624846 12.2637 0.736258C12.3751 0.84767 12.4377 0.998776 12.4377 1.15634C12.4377 1.3139 12.3751 1.465 12.2637 1.57641L7.33926 6.50009L12.2637 11.4238Z" fill="white" />
                    </svg>

                    <h1>Alterar senha</h1>
                    {wrongPassword && <p className="text-[12px] text-[red]">Senha incorreta !</p>}
                </div>

                <div className="px-3">
                    <form className='flex flex-col text-white mt-4 gap-4' onSubmit={handleChangePassword}>
                        <div className='flex gap-2 text-[13px] flex-col'>
                            <label>Senha Atual</label>
                            <input type="password" ref={password} className='h-[35px] bg-[#343B4F] p-2 text-[14px] rounded-[10px] focus:outline-none' placeholder='digite sua senha' />
                        </div>
                        <div className='flex gap-2 text-[13px] flex-col'>
                            <label>Nova senha</label>
                            <input ref={newPassword} type="password" className='h-[35px] bg-[#343B4F] p-2 text-[14px] rounded-[10px] focus:outline-none' placeholder='digite sua nova senha' />
                        </div>
                        <button type="submit" className='bg-[#478DF8] text-[13px] cursor-pointer rounded-[8px] p-2'>{!disabled ? 'Trocar a senha' : 'Mudando'}</button>
                    </form>
                </div>

            </div>
        </div>
    )
}

export default NewPasswordModal